import { render, staticRenderFns } from "./LinkRecipientDialog.vue?vue&type=template&id=8d487c68&"
import script from "./LinkRecipientDialog.vue?vue&type=script&lang=ts&"
export * from "./LinkRecipientDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d487c68')) {
      api.createRecord('8d487c68', component.options)
    } else {
      api.reload('8d487c68', component.options)
    }
    module.hot.accept("./LinkRecipientDialog.vue?vue&type=template&id=8d487c68&", function () {
      api.rerender('8d487c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_messages/components/LinkRecipientDialog.vue"
export default component.exports